import {Customer} from '../../_common/types';

export const getFirstGiClient = (customers: Customer[]) => {
  if (customers && customers.length > 0) {
    const filteredCustomers = customers.filter((customer) => Boolean(customer.greenInvoiceClientID));
    return filteredCustomers[filteredCustomers.length - 1]?.greenInvoiceClientID;
  } else return null;
};